/* eslint-disable quotes */
import { Admin, AdminStudent, ExportFormat } from '../../../shared';
import { IDiscriminator } from '../../../shared';

export interface StudentItemProps {
  admin: Admin;
  students: AdminStudent[],
  showReportSelectors: boolean,
  fromQuiz: boolean,
  setReportOnScreen: React.Dispatch<React.SetStateAction<boolean>>;
  printSignal: boolean;
  exportSignal: ExportFormat;
  origUrl: string;
}

// must change if column order changes or columns added or removed
export const SEQUENCE_COLUMN = 0;
export const DESCRIPTION_COLUMN = 1;
export const SCORE_COLUMN = 2;
export const RESPONSE_COLUMN = 3;
export const RESULT_COLUMN = 4;

export const COLUMN_MAPPING: { [key: number]: number } = {
  0: SEQUENCE_COLUMN,
  1: DESCRIPTION_COLUMN,
  2: SCORE_COLUMN,
  3: RESPONSE_COLUMN,
  4: RESULT_COLUMN
};

export const CORRECT_STRING_VALUE = 'CHECK';
export const INCORRECT_STRING_VALUE = 'X';
export const PARTIAL_STRING_VALUE = 'EMDASH';

export interface ResultFragmentProps {
  colIndex: number;
  result: string;
}

export interface RowCell {
  stringValue: string;
  dataValue: number;
  rowSpan: number;
  colSpan: number;
}

export interface Row {
  rowCells: RowCell[];
  rowType: number;
}

export interface HeaderInfo {
  'Administration: ': string;
  'Roster: ': string;
  'Student: ': string;
  'Student Item Detail Report': string;
}

export interface Footnote {
  Symbol: string,
  FootnoteText: string,
}

export interface ReportRows {
  footnotes: Footnote[];
  notes: string[];
  rows: Row[];
  headerInfo: HeaderInfo;
}

export interface IStudentItem {
  reportDataExists: boolean;
  resultsNotReady: boolean;
  reportRows: ReportRows[];
}

export interface StudentItemResponse extends IDiscriminator {
  studentItem: IStudentItem;
}


export const SAMPLE_DATA: StudentItemResponse =
{
  studentItem: {
    reportDataExists: true,
    resultsNotReady: false,
    reportRows: [{
      headerInfo: {
        'Administration: ': 'admin',
        'Roster: ': 'roster',
        'Student: ': 'student',
        'Student Item Detail Report': 'report'
      },
      "footnotes": [],
      "notes": [
        "NOTE: Items 1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 and 25 were not shown because certain constructed response items cannot be scored automatically."
      ],
      rows: [{
        'rowCells': [
          {
            'stringValue': 'Item Sequence #',
            'dataValue': -1.0,
            'rowSpan': 1,
            'colSpan': 1
          },
          {
            'stringValue': 'Description',
            'dataValue': -1.0,
            'rowSpan': 1,
            'colSpan': 1
          },
          {
            'stringValue': 'Score',
            'dataValue': -1.0,
            'rowSpan': 1,
            'colSpan': 1
          },
          {
            'stringValue': 'Full Credit Response',
            'dataValue': -1.0,
            'rowSpan': 1,
            'colSpan': 1
          },
          {
            'stringValue': 'Result',
            'dataValue': -1.0,
            'rowSpan': 1,
            'colSpan': 1
          }
        ],
        'rowType': 0
      }, {
        "rowCells": [
          {
            "stringValue": "2.",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Identify which figures are composites of two given shapes",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Incorrect",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Correct",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "X",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          }
        ],
        "rowType": 1
      },
      {
        "rowCells": [
          {
            "stringValue": "2.",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Identify which figures are composites of two given shapes",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Incorrect",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Correct",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "X",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          }
        ],
        "rowType": 1
      },
      {
        "rowCells": [
          {
            "stringValue": "2.",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Identify which figures are composites of two given shapes",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Incorrect",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "Correct",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          },
          {
            "stringValue": "X",
            "dataValue": -1.0,
            "rowSpan": 1,
            "colSpan": 1
          }
        ],
        "rowType": 1
      },
      ]
    }]
  },
  __typename: 'StudentItemDigitalResponse'
};
